import { useEffect, useState } from 'react';

export type ThemePref = 'dark' | 'light' | 'system';
const KEY = 'tj_theme';
const media = () => window.matchMedia('(prefers-color-scheme: light)');

export function getThemePref(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch { /* storage unavailable */ }
  return 'dark';
}

function resolve(pref: ThemePref) {
  return pref === 'system' ? (media().matches ? 'light' : 'dark') : pref;
}

export function setThemePref(pref: ThemePref) {
  try { localStorage.setItem(KEY, pref); } catch { /* ignore */ }
  apply();
}

function apply() {
  const theme = resolve(getThemePref());
  if (document.documentElement.dataset.theme !== theme) {
    document.documentElement.dataset.theme = theme;
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'light' ? '#ffffff' : '#111924'); // the header color, so the status bar blends in
    window.dispatchEvent(new Event('tj:theme'));
  }
}

export function initTheme() {
  apply();
  media().addEventListener('change', () => { if (getThemePref() === 'system') apply(); });
}

/** Changes whenever the resolved theme changes, so canvas charts can redraw with the new colors. */
export function useThemeVersion() {
  const [v, setV] = useState(0);
  useEffect(() => {
    const on = () => setV((x) => x + 1);
    window.addEventListener('tj:theme', on);
    return () => window.removeEventListener('tj:theme', on);
  }, []);
  return v;
}
